import { Button } from '@cloudscape-design/components';
import { getPathName } from 'features/plc/contracts/pressHMI.schema';
import { usePLCWriteState } from 'features/plc/providers/PLCProvider';
import PropTypes from 'prop-types';
import React from 'react';

function PLCButton({
  path,
  value,
  children,
  variant = 'normal',
  disabled = false,
  fullWidth = false,
}) {
  const { activeWrite, runWrite } = usePLCWriteState();
  const handle = getPathName(path);

  return (
    <Button
      variant={variant}
      loading={activeWrite === handle}
      disabled={disabled}
      fullWidth={fullWidth}
      onClick={() => runWrite({ path, value })}
    >
      {children}
    </Button>
  );
}

PLCButton.propTypes = {
  path: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  ]).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['normal', 'primary', 'link', 'icon', 'inline-icon', 'inline-link']),
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default PLCButton;
